import React, { useContext } from "react";


import axios from "axios";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Global, { isAdminAccount, isBusinessAccountType } from "../../util/Global";
import { useTranslation } from "react-i18next";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { AlertContext } from "../../util/Alerter";
import { LoaderComponent } from "../../util/Loader";
import NotFound from "../../components/NotFound";
import { Search as SearchIcon } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';


import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton,
  Typography, TextField,
  Avatar,
  Tooltip
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import BlockIcon from '@mui/icons-material/Block';
import CheckIcon from '@mui/icons-material/Check';
import Pagination from "../../components/Pagination";
import { SortTabCell } from "../../components/Utils";



const AdminUsers = () => {
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const { t } = useTranslation();
  const { showAlert } = useContext(AlertContext)
  const [paginatedItems, setpaginatedItems] = useState([])
  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [sortDirection, setSortDirection] = useState('desc');
  const [sortColumn, setSortColumn] = useState('date');
  const [sortedItems, setsortedItems] = useState([])


  const USERS_URL = Global.backend + "/index.php/user/showallUsers";
  const DELETE_USER_URL = Global.backend + "/index.php/api/user/delete";
  const BLOCKED_USER_URL = Global.backend + "/index.php/api/user/blocked";
  const NOTBLOCKED_USER_URL = Global.backend + "/index.php/api/user/notblocked";
  const VALIDATE_USER_URL = Global.backend + "/index.php/api/user/validate";





  useEffect(() => {
    setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
    setpageTitle("userList")
    setalertTitle("")
    setnavLinks([])
  }, [])


  useEffect(() => {
    setisLoading(true)
    fetchUsers();
  }, []);




  function fetchUsers() {
    axios.post(USERS_URL, { userId: localStorage.getItem("id") })
      .then((response) => {
        setUsers(response.data);
        setFilteredUsers(response.data)
      }).catch(() => {
        showAlert("error", t("request.errorFetchingUsers"))
      })
      .finally(() => {
        setisLoading(false);
      });
  }




  const alertShow = (alertText, callback) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success ml-3",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: t("alertTitle.confirm"),
        text: alertText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("alertButton.ok"),
        cancelButtonText: t("alertButton.cancel"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          callback()
        }
      });
  };








  function handleDelete(userId) {
    alertShow(t("deleteUser"), () => {
      setisLoading(true)
      axios.post(DELETE_USER_URL, { userSenderId: localStorage.getItem("id"), userId: userId })
        .then(() => {
          showAlert("success", t("user.deleted"))
          fetchUsers()
        }).catch(() => {
          showAlert("error", t("request.errorDeletingUser"))
        }).finally(() => {
          setisLoading(false)
        })
    })
  }


  function handleBlock(userId, blocked) {
    alertShow(t(blocked ? "unblockUser" : "blockUser"), () => {
      setisLoading(true)
      axios.post(blocked ? NOTBLOCKED_USER_URL : BLOCKED_USER_URL, { userSenderId: localStorage.getItem("id"), userId: userId })
        .then(() => {
          showAlert("success", t(blocked ? "user.unblocked" : "user.blocked"))
          fetchUsers()
        }).catch(() => {
          showAlert("error", t(blocked ? "request.errorUnBlockingUser" : "request.errorBlockingUser"))
        }).finally(() => {
          setisLoading(false)
        })
    })
  }



  function handleValidate(userId) {
    alertShow(t("validateUser"), () => {
      setisLoading(true)
      axios.post(VALIDATE_USER_URL, { userSenderId: localStorage.getItem("id"), userId: userId })
        .then(() => {
          showAlert("success", t("user.validated"))
          fetchUsers()
        }).catch(() => {
          showAlert("error", t("request.errorValidatingUser"))
        }).finally(() => {
          setisLoading(false)
        })
    })
  }






  const handleSearch = (e) => {
    setSearch(e.target.value);
    const filtered = users.filter(user =>
      user.nom.toLowerCase().includes(e.target.value.toLowerCase()) ||
      user.prenom.toLowerCase().includes(e.target.value.toLowerCase()) ||
      user.email.toLowerCase().includes(e.target.value.toLowerCase()) ||
      user.entreprise?.email.toLowerCase().includes(e.target.value.toLowerCase()) ||
      user.entreprise?.nom.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setFilteredUsers(filtered);
  };


  useEffect(() => {
    const sortedItems = [...filteredUsers].sort((a, b) => {
      if (sortDirection === 'asc') {
        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      }
    });
    setsortedItems(sortedItems)
  }, [sortDirection, sortColumn, filteredUsers]);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  }


  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading && (
        !users.length ? <NotFound /> :
          <div className="container-fluid">
            <div className="row">
              <div className="card">
                <div className="card-body">
                  <TextField
                    label="Search"
                    variant="outlined"
                    value={search}
                    onChange={handleSearch}
                    fullWidth
                    margin="normal"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon />
                        </IconButton>
                      ),
                    }}
                  />

                  {!paginatedItems.length ? (
                    <NotFound />
                  ) : (
                    <TableContainer component={Paper} className="mt-3">
                      <Table>
                        <TableHead>
                          <TableRow >
                            <TableCell>{t("user.avatar")}</TableCell>
                            <SortTabCell title={t("user.firstName")} label={"prenom"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                            <SortTabCell title={t("user.lastName")} label={"nom"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                            <SortTabCell title={t("user.mail")} label={"email"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                            <SortTabCell title={t("user.phone")} label={"telephone"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                            <SortTabCell title={t("user.pays")} label={"pays"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                            <TableCell>{t("user.companyName")}</TableCell>
                            <TableCell>{t("user.accountType")}</TableCell>
                            <TableCell>{t("status")}</TableCell>
                            <TableCell>{t("action")}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {paginatedItems.map((user, index) => (
                            <TableRow key={index} selected={user.id == localStorage.getItem("id")}>
                              <TableCell>
                                <Avatar
                                  src={user.photo ? `${Global.backend}/uploads/${user.photo}` : isBusinessAccountType(user.compte) && `${Global.backend}/uploads/${user.entreprise?.logo}`}
                                  alt="User profile"
                                  sx={{ width: 50, height: 50 }}
                                >{user.prenom[0] + user.nom[0]}
                                </Avatar>
                                </TableCell>
                              <TableCell>{user.prenom}</TableCell>
                              <TableCell>{user.nom}</TableCell>
                              <TableCell>{user.email}</TableCell>
                              <TableCell>{user.telephone}</TableCell>
                              <TableCell>{user.pays || "-"}</TableCell>

                              <TableCell>{isBusinessAccountType(user.compte) ? user.entreprise.nom : "-"}</TableCell>

                              <TableCell>
                                <Typography color={isBusinessAccountType(user.compte) ? "primary" : "black"}>{isBusinessAccountType(user.compte) ? t("seller") : t("buyer")}</Typography>
                                <Typography sx={{ fontWeight: "bold" }} color={"secondary"}>{isAdminAccount(user.roles) ? "(" + t("admin") + ")" : ""}</Typography>
                                <Typography sx={{ fontWeight: "bold" }} color={"primary"}>{user.id == localStorage.getItem("id") ? "(" + t("me") + ")" : ""}</Typography>
                              </TableCell>
                              <TableCell>
                                <Typography color={(user.is_blocked || !user.is_valid) ? "error" : "green"}>{t(user.is_blocked ? "user.blocked" : !user.is_valid ? "user.invalid" : "user.validated")}</Typography>
                              </TableCell>
                              <TableCell>


                                <Tooltip title={t("view")}>
                                  <IconButton
                                    color="info"
                                    onClick={() => navigate("/dashboard/admin/modifierprofile/" + user.id)}
                                  >
                                    <VisibilityIcon />
                                  </IconButton>
                                </Tooltip>


                                <Tooltip title={t("delete")}>
                                  <IconButton
                                    disabled={user.id == localStorage.getItem("id")}
                                    color="error"
                                    onClick={() => handleDelete(user.id)}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Tooltip>


                                <Tooltip title={t(user.is_blocked ? "unblock" : "block")}>
                                  <IconButton
                                    disabled={user.id == localStorage.getItem("id")}
                                    color={user.is_blocked ? "info" : "error"}
                                    onClick={() => handleBlock(user.id, user.is_blocked)}
                                  >
                                    <BlockIcon />
                                  </IconButton>
                                </Tooltip>


                                <Tooltip title={t("validate")}>
                                  <IconButton
                                    color="success"
                                    disabled={user.is_valid}
                                    onClick={() => handleValidate(user.id)}
                                  >
                                    <CheckIcon />
                                  </IconButton>
                                </Tooltip>

                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                  <Pagination itemsPerPage={10} items={sortedItems} setItems={setpaginatedItems} />
                </div>
              </div>
            </div>
          </div>
      )}
    </LoaderComponent>
  );
};

export default AdminUsers;
